import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "main-container",
  ref: "appRoot"
}
const _hoisted_2 = {
  key: 0,
  class: "dialog-bg"
}
const _hoisted_3 = {
  key: 0,
  class: "toast-message-wrap"
}
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<audio muted id=\"audio1\"></audio><audio muted id=\"audio2\"></audio><audio muted id=\"audio3\"></audio><audio muted id=\"audio4\"></audio><audio muted id=\"audio5\"></audio><audio muted id=\"audio6\"></audio><div class=\"portrait-cover\"><div class=\"icon-rotate\"></div><div class=\"p-label\">请旋转手机用横屏模式游戏</div></div>", 7)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_msg_box_language = _resolveComponent("msg-box-language")!
  const _component_msg_box_setting = _resolveComponent("msg-box-setting")!
  const _component_msg_box_security = _resolveComponent("msg-box-security")!
  const _component_msg_box_agree = _resolveComponent("msg-box-agree")!
  const _component_msg_box_chips = _resolveComponent("msg-box-chips")!
  const _component_msg_box_demo = _resolveComponent("msg-box-demo")!
  const _component_msg_box_rule = _resolveComponent("msg-box-rule")!
  const _component_msg_box_record = _resolveComponent("msg-box-record")!
  const _component_msg_box_message = _resolveComponent("msg-box-message")!
  const _component_msg_box_tip = _resolveComponent("msg-box-tip")!
  const _component_msg_prompt = _resolveComponent("msg-prompt")!
  const _component_msg_box_tip_concent = _resolveComponent("msg-box-tip-concent")!
  const _component_msg_box_confirm_booking = _resolveComponent("msg-box-confirm-booking")!
  const _component_msg_box_media_setting = _resolveComponent("msg-box-media-setting")!
  const _component_msg_required_change_password = _resolveComponent("msg-required-change-password")!
  const _component_app_loader = _resolveComponent("app-loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["app-root", { mobile: _ctx.isMobile }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.initSound && _ctx.initSound(...args)))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_router_view),
        _createVNode(_Transition, { name: "fadein-out" }, {
          default: _withCtx(() => [
            (_ctx.hasVisibleDialog)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_ctx.showLanguageDialogBox)
                    ? (_openBlock(), _createBlock(_component_msg_box_language, { key: 0 }))
                    : _createCommentVNode("", true),
                  (_ctx.showSettingDialogBox)
                    ? (_openBlock(), _createBlock(_component_msg_box_setting, { key: 1 }))
                    : _createCommentVNode("", true),
                  (_ctx.showSecurityDialogBox)
                    ? (_openBlock(), _createBlock(_component_msg_box_security, { key: 2 }))
                    : _createCommentVNode("", true),
                  (_ctx.showAgreeDialogBox)
                    ? (_openBlock(), _createBlock(_component_msg_box_agree, { key: 3 }))
                    : _createCommentVNode("", true),
                  (_ctx.showChipsDialogBox)
                    ? (_openBlock(), _createBlock(_component_msg_box_chips, { key: 4 }))
                    : _createCommentVNode("", true),
                  (_ctx.showDemoLogin)
                    ? (_openBlock(), _createBlock(_component_msg_box_demo, { key: 5 }))
                    : _createCommentVNode("", true),
                  (_ctx.showRuleDialogBox)
                    ? (_openBlock(), _createBlock(_component_msg_box_rule, { key: 6 }))
                    : _createCommentVNode("", true),
                  (_ctx.showRecordDialogBox)
                    ? (_openBlock(), _createBlock(_component_msg_box_record, { key: 7 }))
                    : _createCommentVNode("", true),
                  (_ctx.showMessageDialogBox)
                    ? (_openBlock(), _createBlock(_component_msg_box_message, { key: 8 }))
                    : _createCommentVNode("", true),
                  (_ctx.showMessageDialogTipBox)
                    ? (_openBlock(), _createBlock(_component_msg_box_tip, { key: 9 }))
                    : _createCommentVNode("", true),
                  (_ctx.showMessageDialogPrompt)
                    ? (_openBlock(), _createBlock(_component_msg_prompt, { key: 10 }))
                    : _createCommentVNode("", true),
                  (_ctx.showMessageDialogTipBoxConcent)
                    ? (_openBlock(), _createBlock(_component_msg_box_tip_concent, { key: 11 }))
                    : _createCommentVNode("", true),
                  (_ctx.showMessageDialogVipBox)
                    ? (_openBlock(), _createBlock(_component_msg_box_confirm_booking, { key: 12 }))
                    : _createCommentVNode("", true),
                  (_ctx.showMessageDialogMediaSettingBox)
                    ? (_openBlock(), _createBlock(_component_msg_box_media_setting, { key: 13 }))
                    : _createCommentVNode("", true),
                  (_ctx.showRequiredChangePassword)
                    ? (_openBlock(), _createBlock(_component_msg_required_change_password, { key: 14 }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 512),
      _createVNode(_Transition, { name: "fadein-out" }, {
        default: _withCtx(() => [
          (_ctx.toastMessageCounter > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("p", null, _toDisplayString(_ctx.toastMessage), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _hoisted_4
    ], 2),
    (_ctx.showLoading)
      ? (_openBlock(), _createBlock(_component_app_loader, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}